import { combineReducers } from 'redux';
import { productReducers } from './productReducers';
import { cartReducers } from './cartReducers';
import { orderReducers } from './orderReducers';
import { removedItemReducers } from './removedItemReducers';

export default combineReducers({
  products: productReducers,
  cartItems: cartReducers,
  orders: orderReducers,
  removedItems: removedItemReducers,
});
